module.exports = __webpack_public_path__ + "media/5.80f17964.wav";